// import "dayjs"
jQuery(function ($) {
  const temaEnv = window?.drupalSettings?.tema;
  const baseUrl = temaEnv?.sna_accesspass_api;
  const apiToken = temaEnv?.sna_accesspass_api_token;

  const settings = {
    url: baseUrl + "/label/list",
    method: "GET",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
      "Api-Token": apiToken,
    },
    error: function (error) {
      console.log("error", error);
    },
  };
  $.ajax(settings).done(function (response) {
    // console.log("response", response.result.data);
    let html = "";
    const tags = response.result.data;
    // console.log({ tags });
    tags.forEach((tag) => {
      html += `<li class="event-tag block w-full whitespace-nowrap bg-black dark:bg-white px-4 py-2 text-sm font-normal text-white dark:text-black
       hover:bg-white cursor-pointer dark:hover:bg-black dark:hover:text-white hover:text-black" data-tag="${tag.label}">${tag.label}</li>`;
    });

    $(".eventags ul").html(html);
  });

  $(document).on("click", ".event-tag", function () {
    const tag = $(this).data("tag");
    const filteredEvents =
      JSON.parse(sessionStorage.getItem("filteredEvents")) || [];

    // Check if the ID already exists in the array
    if (filteredEvents.indexOf(tag) === -1) {
      // Add the ID to the array
      filteredEvents.push(tag);

      // Store the updated array back in sessionStorage
      sessionStorage.setItem("filteredEvents", JSON.stringify(filteredEvents));
    }
  });

  // Check if an ID is present in the registeredEvent array
  function checkIdInFilteredTag(tag) {
    var tags = JSON.parse(sessionStorage.getItem("filteredEvents")) || [];
    return isIdInArray(tag, tags);
  }
});
